"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const types_1 = __importDefault(require("./types"));
const resolvePayload = (payload, state) => {
    if (typeof payload === 'object') {
        const actionMethod = payload[0];
        const actionArgs = payload[1];
        return actionMethod(state, ...actionArgs);
    }
    else {
        return payload;
    }
};
const promotionsStateReducer = (state, action) => {
    const { payload, type } = action;
    let resolvedPayload = null;
    switch (type) {
        case types_1.default.UPDATE_CART_PRICE_DISCOUNTS:
            resolvedPayload = resolvePayload(payload, state);
            return {
                ...state,
                cartPriceDiscounts: resolvedPayload.newCartPriceDiscounts,
                cartPriceDiscountTotal: resolvedPayload.newDiscountTotal
            };
        case types_1.default.UPDATE_APPLIED_VALUE_COUPONS:
            resolvedPayload = resolvePayload(payload, state);
            return { ...state, valueDiscounts: resolvedPayload };
        default:
            return state;
    }
};
exports.default = promotionsStateReducer;
//# sourceMappingURL=reducer.js.map